import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import { LanguageProvider } from './contexts/LanguageContext';
import { getPreferredLanguage } from './utils/languageDetection';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Get initial language from URL or browser
const initialLanguage = getPreferredLanguage();

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <LanguageProvider initialLanguage={initialLanguage}>
        <App />
      </LanguageProvider>
    </React.StrictMode>,
    rootElement
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <LanguageProvider initialLanguage={initialLanguage}>
        <App />
      </LanguageProvider>
    </React.StrictMode>,
    rootElement
  );
}
